import { Badge } from '@apps/web/components/ui/badge';
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from '@apps/web/components/ui/tooltip';
import { cn } from '@apps/web/lib/utils';
import { type Mode } from '@libraries/typescript/api_client';

type AdminModeBadgeProps = {
    readonly mode: Mode;
};

export function AdminModeBadge({ mode }: AdminModeBadgeProps) {
    return (
        <Tooltip>
            <TooltipTrigger asChild={true}>
                <Badge
                    variant="outline"
                    className={cn(
                        mode === 'sandbox'
                            ? 'border-orange-200 bg-orange-50 text-orange-700 dark:border-orange-900 dark:bg-orange-950 dark:text-orange-400'
                            : 'border-green-200 bg-green-50 text-green-700 dark:border-green-900 dark:bg-green-950 dark:text-green-400',
                    )}
                >
                    <span
                        className={cn(
                            'h-1.5 w-1.5 rounded-full',
                            mode === 'sandbox'
                                ? 'bg-orange-500'
                                : 'bg-green-500',
                        )}
                    />
                    {mode}
                </Badge>
            </TooltipTrigger>
            <TooltipContent side="top">
                This action runs in the {mode} environment.
            </TooltipContent>
        </Tooltip>
    );
}
